import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-purple-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="text-center">
          <h3 className="text-2xl font-bold mb-3" style={{textShadow: '0 2px 20px rgba(0,0,80,.2)'}}>Offbeat Crew</h3>
          <p className="text-white/80 mb-4 leading-relaxed max-w-2xl mx-auto">
            Bringing joy to Bay Area through spontaneous flash mobs and fusion dance performances. 
            Endless possibilities, one mission: make people smile through dance.
          </p>
        </div>

        <div className="border-t border-white/20 mt-4 pt-4">
          <div className="text-center">
            <p className="text-white/60 text-sm">
              {currentYear} Offbeat Crew. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
